import { createSlice } from '@reduxjs/toolkit'

export const featureCollectionData = createSlice({
  name: 'featureCollection',
  initialState: {
    data: {
      type: 'FeatureCollection',
      features: [],
    },
    temporal: [],
    temporaryOptionsSpecie: null,
    enableSaveButton: {
      specieField: { error: false, selected: null },
      siteField: { error: false, selected: null },
      siteAcronym: { error: false, selected: null },
      sectionField: { error: false, selected: null },
      pseudonymField: { error: false, selected: null },
    },
  },
  reducers: {
    features: (state, action) => {
      state.data = action.payload
    },
    updateFeatures: (state, action) => {
      const { someId, someValue } = action.payload
      state.data.features[someId].properties = someValue
    },
    saveTemporalFeatures: (state, action) => {
      state.temporal = action.payload
    },
    saveTemporaryOptionsSpecie: (state, action) => {
      state.temporaryOptionsSpecie = action.payload
    },
    setEnableSpecieField: (state, action) => {
      state.enableSaveButton.specieField = action.payload
    },
    setEnableSiteField: (state, action) => {
      state.enableSaveButton.siteField = action.payload
    },
    setEnableAcronymField: (state, action) => {
      state.enableSaveButton.siteAcronym = action.payload
    },
    setEnableSectionField: (state, action) => {
      state.enableSaveButton.sectionField = action.payload
    },
    setEnablePseudonymField: (state, action) => {
      state.enableSaveButton.pseudonymField = action.payload
    },
  },
})

export const {
  features,
  updateFeatures,
  saveTemporalFeatures,
  saveTemporaryOptionsSpecie,
  setEnableSpecieField,
  setEnableSiteField,
  setEnableAcronymField,
  setEnableSectionField,
  saveTemporalInputPseudonym,
  setEnablePseudonymField,
} = featureCollectionData.actions
export default featureCollectionData.reducer
